import * as React from "react";
import { forwardRef } from "react";
const SvgExclamation = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 5, height: 19, viewBox: "0 0 5 19", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "currentColor", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("path", { d: "M2.503.939A1.884 1.884 0 0 0 .53 2.728v.184l.447 9.025c.026.79.71 1.42 1.526 1.368a1.43 1.43 0 0 0 1.368-1.368l.448-9.025c.026-1.026-.79-1.92-1.816-1.973zM1.003 18.357a1.971 1.971 0 1 0 2.79-2.789 1.971 1.971 0 1 0-2.79 2.79z" })));
const ForwardRef = forwardRef(SvgExclamation);
export default ForwardRef;
